/* global SearchEnabled */

import React from 'react';
import _ from 'lodash';
import { getUrlTarget } from 'helpers/ContentHelper';
import classNames from 'classnames';
import { Link } from 'react-router';
import Icon from 'components/Icon';
import { helperGetFindUrl } from 'helpers/RouteHelper';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';
import HeaderLink from '../HeaderLink';
import style from './HeaderIcons.module.scss';

export const SearchIcon = onSearchClick => {
  if (!SearchEnabled) return null;

  const icon = <Icon icon="search" ariaHidden />;
  const searchIconClasses = [style.rightIcon, style.searchIcon, style.searchIconInOrder];

  const props = {
    className: classNames(searchIconClasses),
    key: 'headerSearchIcon',
    onClick: onSearchClick,
    'aria-label': 'search the site',
    to: helperGetFindUrl(),
  };
  return HeaderLink(props, icon);
};

export const StoreIcon = () => {
  const storeUrl = _.get(window.ExternalConfig, 'storeUrl');
  if (!storeUrl) return null;
  const targetData = getUrlTarget(storeUrl);
  const icon = <Icon icon="store-tag" ariaHidden />;
  const props = {
    className: classNames(style.rightIcon, style.storeIcon),
    key: 'headerStoreIcon',
    href: storeUrl,
    'aria-label': 'visit our store to shop',
    onClick: () => {
      handleAnalytics(
        {
          event: Events.GLOBAL_NAV_CLICKED,
          payload: { page_item_title: 'Store' },
        },
        { event: Events.SHOP_NOW_BUTTON_CLICKED },
      );
    },
  };
  const linkProps = { ...props, ...targetData };
  return <Link {...linkProps}>{icon}</Link>;
};
